module.exports = __webpack_public_path__ + "static/img/6262_phase_function_Paper_Points.8a94425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6262_phase_function_Paper_Points.png
// module id = VVw/
// module chunks = 0